MARKDOWN_PARSE_RULES